import { useState, useEffect } from "react";
import { Modal, Text, Flex, Button, Stack, Box, CloseButton } from "@mantine/core";
import trpc from "@/shared/utils/trpc";

interface AcceptInterestModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function AcceptInterestModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
}: AcceptInterestModalProps) {
  const [engagementFeeCredits, setEngagementFeeCredits] = useState(14);

  useEffect(() => {
    if (opened) {
      trpc.paymentConfig.get.query().then((config) => {
        setEngagementFeeCredits(config.engagementFeeCredits);
      });
    }
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="auto"
      withCloseButton={false}
      padding="md"
      styles={{
        header: { display: "none" },
      }}
    >
      <Stack gap="md">
        <Flex align="center" gap={4} wrap="nowrap">
          <Text
            component="h2"
            fw={700}
            fz="md"
            c="slate.8"
            lh={0.8}
            m={0}
            style={{ whiteSpace: "nowrap" }}
          >
            You're about to accept a collaboration request
          </Text>
          <CloseButton onClick={onClose} size="sm" aria-label="Close" />
        </Flex>
        <Box
          p="md"
          style={{
            border: "1px solid #2563EB33",
            backgroundColor: "#2563EB0D",
            borderRadius: "md",
          }}
        >
          <Text fz="sm" mb="xs">
            This will:
          </Text>
          <Stack gap={4}>
            <Text fz="sm">• Create a mutual match</Text>
            <Text fz="sm">• Require collaboration payment ({engagementFeeCredits} Credits)</Text>
            <Text fz="sm">• Unlock full company details</Text>
            <Text fz="sm">• Activate workspace</Text>
          </Stack>
        </Box>

        <Flex justify="flex-end">
          <Button onClick={onConfirm} loading={isLoading}>
            Confirm & Proceed
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}
